import { useNavigate, useParams } from 'react-router-dom'

import { useUnsafeCallback, useUnsafeEffect } from '@factorialco/deprecated-design-system'
import { FinanceCostCenterDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DetailsPanel from 'modules/finance/components/CostCenterDetails/DetailsPanel'

const CostCentersListPageEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { company } = useCurrentSession()

  const { data, loading } = useQuery(FinanceCostCenterDocument, {
    variables: {
      id: String(id),
      companyId: company.id,
    },
  })

  const onClose = useUnsafeCallback(() => {
    navigate(navigation.settings.finance.costCenters.list.fullPath())
  }, [navigate, navigation])

  const costCenter = data?.finance.costCentersConnection.nodes?.[0]

  useUnsafeEffect(() => {
    if (!loading && !costCenter) onClose()
  }, [loading, onClose, costCenter])

  if (loading) return <Loading />

  if (!costCenter) return null

  return <DetailsPanel open onClose={onClose} costCenter={costCenter} />
}

export default CostCentersListPageEdit
